import { IRest } from "./rest.interface";
import { EnumReminderType } from "./enums";

export class Reminder implements IRest {
    className = 'Lembrete';

    id!: number;
    title!: string;
    date!: string;
    time!: string;
    done!: boolean;
    type!: EnumReminderType;
    remainingDays!: number; //Uso Interno

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            id: this.id || undefined,
            title: this.title,
            date: this.date,
            time: this.time.slice(0, 5),
            done: this.done,
            type: this.type
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.id = data['id'] || 0;
            this.title = data['title'] || '';
            this.date = data['date'] || '';
            this.time = data['time'] || '';
            this.done = data['done'] || false;
            this.type = <EnumReminderType>(data['type'] || EnumReminderType.Others);
            this.remainingDays = GetRemainingDays(this.date);
        }
        return this;
    }

}

//Obter Quantidade de Dias Restantes
function GetRemainingDays(date: string): number {
    const dt = new Date(date);
    let currentDate = new Date();

    let days = Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate())) / (1000 * 60 * 60 * 24));
    return days;
}